// Canonical site configuration. One source of truth for absolute URLs.
// Kept as a hardcoded constant so it's identical on server and client bundles.
export const SITE_URL = "https://buddhaka.com";
export const SITE_NAME = "Buddha KA · KAfrequency";

/** Build an absolute URL from a site-relative path. */
export function absoluteUrl(path: string): string {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
